
import '../footer/about.css';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faHeadset,
  faEnvelope,
  faQuestionCircle,
  faComments,
  faCheckCircle,
  faClock,
  faPhone
} from "@fortawesome/free-solid-svg-icons";

const Ajutor = () => {
  const [formData, setFormData] = useState({
    nume: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    // Aici va fi logica de trimitere la backend
    // Deocamdată simulăm trimiterea
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({ nume: '', email: '', message: '' });
      
      // Resetăm mesajul de succes după 5 secunde
      setTimeout(() => setSubmitStatus(''), 5000);
    }, 1000);
  };

  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">
        
        <section className='section-about-1'>
          <div>
            <h3 className='align-about-ab'>
              <span className='acasa-about-footer'>Acasa</span>
              <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-icon" />
              <span className='color-despre'>Contact</span>
            </h3>
          </div>
        </section>

        <div className='tittle-ab-top'>
          <h4>Contact</h4>
        </div>

        {/* Introducere */}
        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faHeadset} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
          <div className='part-text-about'>
            <h4>Cum te putem ajuta?</h4>
            <p>
              Echipa ContaLearn este aici pentru tine! Dacă ai întrebări despre platformă, cursuri, 
              cont sau orice altă problemă, nu ezita să ne contactezi.
            </p>
            <p>
              Completează formularul de mai jos și îți vom răspunde în cel mai scurt timp posibil, 
              de obicei în maximum 48 de ore lucrătoare.
            </p>
            <p>
              <strong>Important:</strong> Pentru întrebări frecvente, consultă mai întâi pagina noastră de 
              <a href='/faq' style={{color: '#13b8ab', fontWeight: 'bold'}}> Întrebări Frecvente</a> — 
              poate găsești răspunsul imediat!
            </p>
          </div>
        </section>

        {/* Formular de contact */}
        <section className='section-about-2'>
          <div className='part-text-about' style={{width: '100%'}}>
            <h4>
              <FontAwesomeIcon icon={faEnvelope} style={{marginRight: '10px', color: '#13b8ab'}} />
              Trimite-ne un mesaj
            </h4>
            
            {submitStatus === 'success' && (
              <div style={{
                background: '#d4edda',
                color: '#155724',
                padding: '15px',
                borderRadius: '10px',
                marginBottom: '20px',
                border: '1px solid #c3e6cb',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <FontAwesomeIcon icon={faCheckCircle} style={{fontSize: '24px'}} />
                <div>
                  <strong>Mesaj trimis cu succes!</strong>
                  <p style={{margin: '5px 0 0 0'}}>Îți vom răspunde în maximum 48 de ore lucrătoare.</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} style={{marginTop: '20px'}}>
              <div style={{marginBottom: '20px'}}>
                <label htmlFor="nume" style={{display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333'}}>
                  Nume și prenume *
                </label>
                <input
                  type="text"
                  id="nume"
                  name="nume"
                  value={formData.nume}
                  onChange={handleChange}
                  placeholder="Ex: Ion Popescu"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '2px solid #e0e0e0',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#13b8ab'}
                  onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                />
              </div>

              <div style={{marginBottom: '20px'}}>
                <label htmlFor="email" style={{display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333'}}>
                  Adresă de email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="exemplu@email.ro"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '2px solid #e0e0e0',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#13b8ab'}
                  onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                />
              </div>

              <div style={{marginBottom: '20px'}}>
                <label htmlFor="message" style={{display: 'block', marginBottom: '8px', fontWeight: '600', color: '#333'}}>
                  Mesajul tău *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Descrie problema sau întrebarea ta cât mai detaliat..."
                  required
                  rows="6"
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '8px',
                    border: '2px solid #e0e0e0',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#13b8ab'}
                  onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                />
              </div>

              <button
                type="submit"
                disabled={submitStatus === 'sending'}
                style={{
                  background: submitStatus === 'sending' ? '#ccc' : 'linear-gradient(135deg, #13b8ab 0%, #0e9688 100%)',
                  color: 'white',
                  padding: '14px 32px',
                  borderRadius: '8px',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: submitStatus === 'sending' ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}
                onMouseEnter={(e) => {
                  if (submitStatus !== 'sending') {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(19, 184, 171, 0.3)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <FontAwesomeIcon icon={faEnvelope} />
                {submitStatus === 'sending' ? 'Se trimite...' : 'Trimite mesajul'}
              </button>

              <p style={{marginTop: '15px', fontSize: '14px', color: '#666'}}>
                * Câmpuri obligatorii
              </p>
            </form>
          </div>
        </section>

        {/* Diferenta fata de FAQ */}
        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faQuestionCircle} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
          <div className='part-text-about'>
            <h4>Întrebări Frecvente vs Contact Direct</h4>
            <div style={{display: 'flex', gap: '20px', marginTop: '20px', flexWrap: 'wrap'}}>
              <div style={{flex: '1', minWidth: '250px', background: '#f0f9f8', padding: '20px', borderRadius: '10px', border: '2px solid #13b8ab'}}>
                <h5 style={{color: '#13b8ab', marginBottom: '10px'}}>
                  <FontAwesomeIcon icon={faQuestionCircle} style={{marginRight: '8px'}} />
                  Întrebări Frecvente
                </h5>
                <ul style={{paddingLeft: '20px'}}>
                  <li>Răspunsuri imediate</li>
                  <li>Întrebări comune</li>
                  <li>Disponibil 24/7</li>
                  <li>Auto-servire</li>
                </ul>
                <a href='/faq' style={{display: 'inline-block', marginTop: '15px', color: '#13b8ab', fontWeight: 'bold', textDecoration: 'none'}}>
                  Consultă pagina →
                </a>
              </div>
              
              <div style={{flex: '1', minWidth: '250px', background: '#f0f9f8', padding: '20px', borderRadius: '10px', border: '2px solid #13b8ab'}}>
                <h5 style={{color: '#13b8ab', marginBottom: '10px'}}>
                  <FontAwesomeIcon icon={faComments} style={{marginRight: '8px'}} />
                  Contact Direct (această pagină)
                </h5>
                <ul style={{paddingLeft: '20px'}}>
                  <li>Probleme specifice</li>
                  <li>Răspuns personalizat</li>
                  <li>Suport dedicat</li>
                  <li>48h răspuns</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Alte moduri de contact */}
        <section className='section-about-2'>
          <div className='part-text-about'>
            <h4>Alte modalități de contact</h4>
            <div style={{background: '#f0f9f8', padding: '20px', borderRadius: '10px', marginTop: '15px', border: '2px solid #13b8ab'}}>
              <div style={{marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px'}}>
                <FontAwesomeIcon icon={faEnvelope} style={{fontSize: '24px', color: '#13b8ab'}} />
                <div>
                  <strong>Email direct:</strong> suport@contalearn.ro
                </div>
              </div>
              <div style={{marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px'}}>
                <FontAwesomeIcon icon={faClock} style={{fontSize: '24px', color: '#13b8ab'}} />
                <div>
                  <strong>Program răspuns:</strong> Luni - Vineri, 09:00 - 18:00
                </div>
              </div>
              <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                <FontAwesomeIcon icon={faCheckCircle} style={{fontSize: '24px', color: '#13b8ab'}} />
                <div>
                  <strong>Timp mediu de răspuns:</strong> Maximum 48 ore lucrătoare
                </div>
              </div>
            </div>
            <p style={{marginTop: '20px', fontSize: '14px', color: '#666'}}>
              <strong>Notă:</strong> Pentru probleme urgente legate de cont sau plăți, te rugăm să ne contactezi direct la suport@contalearn.ro 
              menționând "URGENT" în subiect.
            </p>
          </div>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faPhone} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
          </div>
        </section>

        <div className='line-about'></div>
      </div>
    </div>
  );
};

export default Ajutor;